"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
exports.default = vue_1.default.extend({
    name: "dropdown-multiselect",
    props: {
        options: {
            type: Array,
            required: true
        },
        currentOptions: {
            type: Array,
            required: true
        }
    },
    mounted: function () {
        $(".selectpicker").selectpicker();
    },
    data: function () {
        return {
            _options: this.options,
            selectedOptions: this.currentOptions
        };
    },
    watch: {
        options: function () {
            this.$data._options = this.options;
            this.$nextTick(function () {
                $(".selectpicker").selectpicker("refresh");
            });
        },
        selectedOptions: function () {
            var _this = this;
            this.$emit("change", this.selectedOptions.map(function (selectedOption) { return _this.$data._options.find(function (option) { return option.value === selectedOption; }); }));
        }
    }
});
